import { render, staticRenderFns } from "./ScalePlugin.vue?vue&type=template&id=a7b7f938&scoped=true"
import script from "./ScalePlugin.vue?vue&type=script&lang=ts"
export * from "./ScalePlugin.vue?vue&type=script&lang=ts"
import style0 from "./ScalePlugin.vue?vue&type=style&index=0&id=a7b7f938&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b7f938",
  null
  
)

export default component.exports